<template>
  <div class='massLoss-list' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='委托商名称：'>
          <el-input v-model='searchForm.consignorName' size='mini'
                    placeholder='请输入委托商名称'></el-input>
        </el-form-item>
        <el-form-item label='批次号：'>
          <el-input v-model='searchForm.batchNumber' size='mini' placeholder='请输入批次号'></el-input>
        </el-form-item>
        <el-form-item label='运单编号：'>
          <el-input v-model='searchForm.waybillNo' size='mini' placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='车架号：'>
          <el-input v-model='searchForm.frameNumber' size='mini' placeholder='请输入车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}"></el-input>
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='searchForm.brandName' size='mini' placeholder='请输入品牌'></el-input>
        </el-form-item>
        <el-form-item label='型号（车型）：'>
          <el-input v-model='searchForm.modelName' size='mini' placeholder='请输入型号'></el-input>
        </el-form-item>
        <el-form-item label='计划日期：'>
          <el-date-picker v-model='searchForm.startDateExport' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='开始日期' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.endDateExport' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='结束日期' />
        </el-form-item>
        <el-form-item label='是否导入：'>
          <el-select v-model='searchForm.isImport' clearable filterable size='mini'
                     placeholder='请选择状态'>
            <el-option :label='"匹配"' :value='0' />
            <el-option :label='"导入"' :value='1' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addSettlement'>添加结算</el-button>
          <el-button size='small' type='primary' @click='searchHistoryBtn'>查询历史记录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn'
                        @triggerLoading='importLoading = !importLoading'/>
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
          @select='handleSelectionChange'
          @select-all='handleSelectionChange'
          :row-style="rowStyle">
          <el-table-column type='selection' align='center' min-width='80px' />
          <el-table-column prop='consignorName' label='委托商名称' align='center' min-width='220px' />
          <el-table-column prop='batchNumber' label='批次号' align='center' min-width='150px' />
          <el-table-column label='运单编号' align='center' min-width='180px'>
            <template slot-scope='scope'>
              {{scope.row.waybillNo ? scope.row.waybillNo: scope.row.waybillNumber}}
            </template>
          </el-table-column>
          <el-table-column prop='frameNumber' label='车架号' align='center' min-width='180px' />
          <el-table-column prop='brandName' label='品牌' align='center' min-width='100px' />
          <el-table-column prop='modelName' label='型号' align='center' min-width='120px' />
          <el-table-column prop='typeName' label='结算方式' align='center' min-width='150px' v-if="historyReveal"/>
          <el-table-column prop='departurePlace' label='起运地' align='center' min-width='280px'>
            <template slot-scope='scope'>
              {{
                `${scope.row.departurePlace}  ${scope.row.departurePort ? '【' + scope.row.departurePort + '】' : ''}`
              }}
            </template>
          </el-table-column>
          <el-table-column prop='arrivePlace' label='目的地' align='center' min-width='280px'>
            <template slot-scope='scope'>
              {{
                `${scope.row.arrivePlace}  ${scope.row.arrivePort ? '【' + scope.row.arrivePort + '】' : ''}`
              }}
            </template>
          </el-table-column>
          <!--          <el-table-column prop='departurePort' label='起运港' align='center' min-width='200px' />-->
          <!--          <el-table-column prop='arrivePort' label='目的港' align='center' min-width='200px' />-->
          <el-table-column label='计划时间' align='center' min-width='100px'>
            <template slot-scope='scope'>
              {{ scope.row.planDate ? scope.row.planDate.substring(0, 10) : '--' }}
            </template>
          </el-table-column>
          <el-table-column label='委托商线路结算' align='center' min-width='120px'>
            <template slot-scope='scope'>
              {{ scope.row.isSettlement ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label='是否结算委托商港口作业结算' align='center' min-width='220px'>
            <template slot-scope='scope'>
              {{ scope.row.isSettlementOther ? '是' : '否' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 添加结算 -->
    <consignor-add-settlement ref='consignorAddSettlementRef' @searchBtn='searchBtn' />
  </div>
</template>

<script>
  import ConsignorAddSettlement
    from '../compontens/consignorAddSettlement/index';
  import {getSpecialHistoryPage, getSpecialPage} from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import BatchImport from '@/components/batchImport';

  export default {
    name: 'consignorSpecialPrice',
    components: { ConsignorAddSettlement,BatchImport },
    data() {
      return {
        searchForm: {
          consignorName: '',
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brandName: '',
          modelName: '',
          startDateExport: '',
          endDateExport: '',
          isImport: 1,
          page: 1,
          rows: 10,
        },
        historyReveal: false,
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        selectTable: [],
        uploadUrl: '/sys/customerSpecialPrice/importExcel',
        importLoading: false,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
   //   this.searchBtn();
    },
    methods: {
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/special/settlement/childCvExport?access_token=${token}&consignorName=${this.searchForm.consignorName}&batchNumber=${this.searchForm.batchNumber}&waybillNo=${this.searchForm.waybillNo}&frameNumber=${this.searchForm.frameNumber}&brandName=${this.searchForm.brandName}&modelName=${this.searchForm.modelName}&startDateExport=${this.searchForm.startDateExport}&endDateExport=${this.searchForm.endDateExport}&isImport=${this.searchForm.isImport}`;
        window.exportExcelGet('/platform/special/settlement/childCvExport', `consignorName=${this.searchForm.consignorName}&batchNumber=${this.searchForm.batchNumber}&waybillNo=${this.searchForm.waybillNo}&frameNumber=${this.searchForm.frameNumber}&brandName=${this.searchForm.brandName}&modelName=${this.searchForm.modelName}&startDateExport=${this.searchForm.startDateExport}&endDateExport=${this.searchForm.endDateExport}&isImport=${this.searchForm.isImport}`)
      },
      dateChange(val) {
        if (this.searchForm.startDateExport && this.searchForm.endDateExport && (this.searchForm.endDateExport <= this.searchForm.startDateExport)) {
          if (val === this.searchForm.endDateExport) this.searchForm.endDateExport = '';
          if (val === this.searchForm.startDateExport) this.searchForm.startDateExport = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      getType(type) {
        switch (type) {
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装卸费';
          case 4:
            return '过驳费';
          case 5:
            return '提车费';
          case 6:
            return '堆存费';
          default:
            return '--';
        }
      },
      // 添加结算
      addSettlement() {
        const id = this.selectTable.map(item => item.consignorId);
        const consignorName = this.selectTable.map(item => item.consignorName);
        const batchNumber = this.selectTable.map(item => item.batchNumber);
        const waybillNumber = this.selectTable.map(item => item.waybillNo);
        const frameNumber = this.selectTable.map(item => item.frameNumber);
        const brandId = this.selectTable.map(item => item.brandId);
        const brandName = this.selectTable.map(item => item.brandName);
        const departurePlace = this.selectTable.map(item =>  `${item.departurePlace}  ${item.departurePort ? '【' + item.departurePort + '】' : ''}`);
        const arrivePlace = this.selectTable.map(item => `${item.arrivePlace}  ${item.arrivePort ? '【' + item.arrivePort + '】' : ''}`);
        const stringDate = this.selectTable.map(item => item.planDate);
        if (this.selectTable.length === 0) return this.$message.warning('请选择数据后添加结算！');
        let consignorFlag = false
        if (this.selectTable.length > 0) {
          const {
            consignorId,
          } = this.selectTable[0];
          this.selectTable.forEach((item) => {
            if (item.consignorId !== consignorId) {
              consignorFlag = true;
            }
          })
        }
        if (consignorFlag) return this.$message.warning('只能选择同一家委托商数据！');
        this.$refs.consignorAddSettlementRef.dialogOpen(this.searchForm.isImport, this.selectTable,id,consignorName,batchNumber,waybillNumber,
          frameNumber,brandId,brandName,departurePlace,arrivePlace,stringDate);
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      searchHistoryBtn(){
        this.historyReveal = true
        this.searchForm.page = 1;
        this.getTableDataList();
      },
      // 获取表格数据
      async getTableDataList() {
        this.tableLoading = true;
        const data = await getSpecialHistoryPage({
          state: 0
        });
        if (data.status !== null) return this.$message.warning(data.message);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total;
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const data = await getSpecialPage(this.searchForm);
        if (data.status == -1) return this.$message.warning(data.message);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.searchForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      handleSelectionChange(val) {
        this.selectTable = val;
      },
      rowStyle({ row }) {
        return this.selectTable.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      //模板下载
      download() {
        window.location.href = '/file/委托商特殊结算导入模板.xlsx';
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
